import React from 'react';

import CommunicationControlsMenu from 'components/customer/communication_controls_menu';
import CompositionTabs from 'components/customer/composition_tabs';
import Conversation from 'models/conversation';
import CustomerContext from 'components/customer/customer_context';
import ResponsePrompt from 'components/customer/response_prompt';
import { useIsFeatureEnabled } from 'components/contexts/is_feature_enabled';

export default function CompositionManager() {
  const isFeatureEnabled = useIsFeatureEnabled();

  return (
    <CustomerContext.Consumer>
      {({ compositionId, customerId, latestConversationId, latestConversationStatus }) => {
        const showResponsePrompt = !(
          isFeatureEnabled('newReplyWorkflow') && latestConversationStatus === Conversation.Status.CLOSED
        );
        const compositionMenu = (
          <CommunicationControlsMenu conversationId={latestConversationId} customerId={customerId} />
        );

        return compositionId ? (
          <div className="compositionManager-open">
            {compositionMenu}
            <CompositionTabs compositionId={compositionId} conversationId={latestConversationId} />
          </div>
        ) : (
          <div className="compositionManager-closed">
            {compositionMenu}
            {showResponsePrompt && <ResponsePrompt conversationId={latestConversationId} />}
          </div>
        );
      }}
    </CustomerContext.Consumer>
  );
}



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/customer/composition_manager.jsx